import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Remove or comment out this function if not needed
// export async function refreshSchemaCache() {
//   try {
//     await supabase.rpc('reload_schema_cache');
//     console.log('Schema cache refreshed successfully');
//   } catch (error) {
//     console.error('Error refreshing schema cache:', error);
//   }
// }

// Add the connection check function
export async function checkSupabaseConnection() {
  try {
    // Simple query to check if we can connect to Supabase
    const { data, error } = await supabase
      .from('user_profiles')
      .select('id')
      .limit(1);
    
    if (error) {
      console.error('Supabase connection test failed:', error);
      return { connected: false, error };
    }
    
    return { connected: true, data };
  } catch (error) {
    console.error('Supabase connection test exception:', error);
    return { connected: false, error };
  }
}
